module.exports = __webpack_public_path__ + "static/media/FeijaoJalo.58d34897.png";